import React, { Component } from 'react';

interface IProps {
    onClick(v: any): void;
    customLabel?: string;
    type?:'primary'|'secondary'|'tertiary'|'transparent'
}

export class StandardButton extends Component<IProps, any> {
    type() {
        return this.props.type ?? 'primary';
    }
    render() {
        return (
            <div className={`btn-${this.type()}`} onClick={this.props.onClick}>{this.props.customLabel ?? 'Next'}</div>
        );
    }
}
